<ion-header class="ion-no-shadow ion-no-border">
    <header-notifications></header-notifications>
    <ion-toolbar class="ion-hide-xl-up">
        <ion-title class="full">{{ 'CREDENTIAL_WALLET_PAGE_TITLE' | trns }}</ion-title>
    </ion-toolbar>
    <ion-row *ngIf="plt.tabMenu && credentials.length > 0"
             class="ion-no-padding ion-align-items-center">
        <ion-col size="12"
                 class="ion-no-padding ion-text-center">
            <a class="top-header-link"
               (click)="shareLink()">
                <svg-icon [applyClass]="true"
                          src="/assets/icons/ico-share.svg"
                          class="icon fill-light">
                </svg-icon>
                <ng-container *ngIf="!someSelected">
                    {{ 'CREDENTIAL_WALLET_SHARE' | trns }}
                </ng-container>
                <ng-container *ngIf="someSelected">
                    {{ 'CREDENTIAL_WALLET_SHARE_SOME' | trns }}
                </ng-container>
            </a>
        </ion-col>
    </ion-row>
</ion-header>

<ion-content class="ion-no-padding">

    <ion-refresher (ionRefresh)="refresh($event)"
                   slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <ion-backdrop *ngIf="showSharing"
                  (ionBackdropTap)="hideSharing()">
    </ion-backdrop>

    <div *ngIf="!loading"
         class="content-box">

        <ion-row *ngIf="!plt.tabMenu"
                 class="ion-no-padding ion-align-items-center">
            <ion-col size="8"
                     class="ion-no-padding">
                <h1 [innerHTML]="'CREDENTIAL_WALLET_PAGE_TITLE' | trns : {event: event?.translate(event?.default_locale).name}">
                </h1>
            </ion-col>
            <ion-col size="4"
                     class="ion-no-padding ion-text-right">
                <ion-button *ngIf="credentials.length > 0"
                            class="set-availability"
                            (click)="shareLink()">
                    <ng-container *ngIf="!someSelected">
                        {{ 'CREDENTIAL_WALLET_SHARE' | trns }}
                    </ng-container>
                    <ng-container *ngIf="someSelected">
                        {{ 'CREDENTIAL_WALLET_SHARE_SOME' | trns }}
                    </ng-container>
                </ion-button>
            </ion-col>
        </ion-row>

        <div class="content-box-inner">
            <div class="content-data">
                <div class="credentials-list">
                    <ng-container *ngIf="credentials.length > 0">
                        <div *ngFor="let credential of credentials"
                             class="item"
                             [ngClass]="{'selected':credential.selected}">
                            <div class="image"
                                 (click)="openPublicDetail(credential)">
                                <img *ngIf="credential.certification_preview"
                                     [src]="plt.createSignedLink(credential.certification_preview)"
                                     [alt]="credential.certification_name" />
                                <img *ngIf="credential.certification_badge"
                                     [src]="plt.createSignedLink(credential.certification_badge)"
                                     [ngClass]="{'badge': !!credential.certification_preview}"
                                     [alt]="credential.certification_name" />
                                <div (click)="toggle(credential)"
                                     class="checkbox"
                                     click-stop-propagation
                                     [ngClass]="{'selected':credential.selected}">
                                    <svg-icon [applyClass]="true"
                                              [src]="'/assets/icons/ico-done.svg'"
                                              class="icon fill-light">
                                    </svg-icon>
                                </div>
                            </div>
                            <div class="details">
                                <div class="pointer"
                                     (click)="openPublicDetail(credential)">
                                    <strong>{{credential.certification_name}}</strong>
                                    <span class="date">{{credential.issued_on | datex: 'dateFormatDefault'}}</span>
                                    <strong>{{credential.certification_issuer}}</strong>
                                </div>
                                <span class="bitcoin">
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/bitcoin.svg"
                                              class="fill-menu-contrast">
                                    </svg-icon>
                                    {{'CREDENTIAL_WALLET_BLOCKCHAIN_ID'| translate}}
                                    <strong *ngIf="credential.blockchain_id">{{credential.blockchain_id}}</strong>
                                    <strong *ngIf="!credential.blockchain_id"
                                            class="help"
                                            [title]="'CREDENTIAL_WALLET_BLOCKCHAIN_ID_PENDING_HELP' | trns">
                                        <span title="">{{'CREDENTIAL_WALLET_BLOCKCHAIN_ID_PENDING'| translate}}</span>
                                    </strong>
                                </span>
                            </div>
                            <div class="links">

                                <a *ngIf="credential.certification_badge"
                                   [title]="'CREDENTIAL_WALLET_DOWNLOAD_BADGE' | trns"
                                   (click)="plt.downloadFile(plt.baseLinkPath + plt.apiPrefix + '/participant/' + user.selected_participant_id + '/credential/' + credential.id + '/download?type=badge&token=' + this.userToken, credential.certification_number + '.png')"
                                   class="pointer"
                                   [ngClass]="{'badge': credential.certification_file, 'single': !credential.certification_file}">
                                    <ion-icon name="download"></ion-icon>
                                </a>
                                <a *ngIf="credential.certification_file"
                                   [title]="'CREDENTIAL_WALLET_DOWNLOAD_CERTIFICATE' | trns"
                                   (click)="plt.downloadFile(plt.baseLinkPath + plt.apiPrefix + '/participant/' + user.selected_participant_id + '/credential/' + credential.id + '/download?type=pdf&token=' + this.userToken, credential.certification_number + '.pdf')"
                                   class="pointer">
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-export-pdf.svg">
                                    </svg-icon>
                                </a>

                                <a [title]="'CREDENTIAL_WALLET_SHARE' | trns"
                                   (click)="showShare(credential);"
                                   href="#">
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-share.svg">
                                    </svg-icon>
                                </a>
                                <div *ngIf="showSharing && credential.showSharing"
                                     [ngClass]="{'both': credential.certification_preview}"
                                     class="sharing">
                                    <ng-container *ngIf="credential.certification_preview">
                                        <strong>{{ 'CREDENTIAL_WALLET_SHARE_CERTIFICATE'| trns}}</strong>
                                        <ng-container *ngFor="let type of sharingOptions">
                                            <div class="share-button"
                                                 (click)="share(type, credential, false)">
                                                <svg-icon [applyClass]="true"
                                                          [src]="'/assets/icons/share/' + type + '.svg'"
                                                          class="icon fill-light">
                                                </svg-icon>
                                            </div>
                                        </ng-container>
                                        <strong>{{ 'CREDENTIAL_WALLET_SHARE_BADGE'| trns}}</strong>
                                    </ng-container>
                                    <ng-container *ngFor="let type of sharingOptions">
                                        <div class="share-button"
                                             (click)="share(type, credential)">
                                            <svg-icon [applyClass]="true"
                                                      [src]="'/assets/icons/share/' + type + '.svg'"
                                                      class="icon fill-light">
                                            </svg-icon>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>

                        <ng-container *ngFor="let i of countSizes[3]; let c = index">
                            <ng-container *ngIf="c < (3 - (credentials.length % 3)) && credentials.length % 3 != 0">
                                <div class="item-empty"></div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="credentials.length == 0">
                        <div class="empty-data">
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/ico-credentials-wallet.svg"
                                      class="icon fill-light">
                            </svg-icon>
                            <h3>
                                {{ 'CREDENTIAL_WALLET_EMPTY' | trns }}
                            </h3>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="loading || !user || !user.id"
         class="content-centered-column">
        <div class="content-centered-row loading">
            <ion-spinner></ion-spinner>
            <h2>{{ 'CREDENTIAL_WALLET_PREPARING' | trns }}</h2>
        </div>
    </div>
</ion-content>